import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const STUDENT = 'student'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: null,
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [STUDENT]: yup
       .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
